import { AppEnv, env } from 'config' // Adjust the import path as necessary
import { UserReferralPartner } from 'types'

export const isKeggWebviewFlow = (
  partner: string | null | undefined,
  forceKeggFlow: string | undefined
): boolean => {
  const isStagingEnv = env.REACT_APP_ENV === AppEnv.Staging

  return (
    partner === UserReferralPartner.Kegg &&
    (isStagingEnv || 'ReactNativeWebView' in window || forceKeggFlow === 'true')
  )
}
